
module.exports = [
  'M7 14 A7 7 0 0 0 0 21 A7 7 0 0 0 7 28 H27 A5 5 0 0 0 32 23 A5 5 0 0 0 27 18 A10 10 0 0 0 28 14 A10 10 0 0 0 18 4 A10 10 0 0 0 8 14 A7 7 0 0 0 7 14'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/cloud.js
 ** module id = 203
 ** module chunks = 0
 **/